class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('ul');
        this.sliderItems = this.querySelectorAll('li');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.rtl_num = document.body.classList.contains('layout_rtl') ? -1 : 1;

        // Configuration: Number of products visible on mobile and desktop
        this.visibleProductsMobile = 2;
        this.visibleProductsDesktop = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);

        // If no slider or buttons are available, stop execution
        if (!this.slider || !this.nextButton) return;

        this.initSlider();

        // Event listeners for navigation buttons
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this, -1));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this, 1));

        // Add touch event listeners for mobile smooth scrolling
        this.slider.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
        this.slider.addEventListener('touchmove', this.onTouchMove.bind(this), { passive: true });
        this.slider.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
    }

    // Initialize slider configurations
    initSlider() {
        // Clone items for infinite scrolling
        this.cloneSliderItems();

        // Ensure the slider is set up correctly on window resize
        window.addEventListener('resize', () => {
            this.visibleProductsDesktop = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
        });
    }

    // Clone slider items for infinite scrolling
    cloneSliderItems() {
        const fragmentBefore = document.createDocumentFragment();
        const fragmentAfter = document.createDocumentFragment();

        this.sliderItems.forEach((item) => {
            const cloneBefore = item.cloneNode(true);
            const cloneAfter = item.cloneNode(true);

            fragmentBefore.appendChild(cloneBefore);
            fragmentAfter.appendChild(cloneAfter);
        });

        this.slider.prepend(fragmentBefore);
        this.slider.appendChild(fragmentAfter);

        // Update slider items list after cloning
        this.sliderItems = this.querySelectorAll('li');
    }

    // Navigation button click handler
    onButtonClick(direction) {
        const visibleProducts = window.innerWidth <= 768 ? this.visibleProductsMobile : this.visibleProductsDesktop;
        const slideAmount = visibleProducts * this.sliderItems[0].clientWidth * this.rtl_num;

        // Move the slider based on direction
        this.slider.scrollLeft += direction * slideAmount;

        // Handle infinite scrolling
        this.handleInfiniteScroll();
    }

    // Handle infinite scrolling
    handleInfiniteScroll() {
        const firstItem = this.sliderItems[0];
        const lastItem = this.sliderItems[this.sliderItems.length - 1];

        if (this.slider.scrollLeft <= 0) {
            this.slider.scrollLeft = lastItem.offsetLeft - this.sliderItems[0].clientWidth;
        }

        if (this.slider.scrollLeft >= lastItem.offsetLeft) {
            this.slider.scrollLeft = firstItem.offsetLeft + this.sliderItems[0].clientWidth;
        }
    }

    // Mobile touch gestures for smooth scrolling
    onTouchStart(event) {
        this.startX = event.touches[0].clientX;
        this.startScrollLeft = this.slider.scrollLeft;
    }

    onTouchMove(event) {
        const moveX = event.touches[0].clientX - this.startX;
        this.slider.scrollLeft = this.startScrollLeft - moveX;
    }

    onTouchEnd() {
        // Snap to the nearest product after touch ends
        const slideWidth = this.sliderItems[0].clientWidth;
        const nearestSlide = Math.round(this.slider.scrollLeft / slideWidth) * slideWidth;

        this.slider.scrollLeft = nearestSlide;

        // Handle infinite scrolling
        this.handleInfiniteScroll();
    }
}

customElements.define('slider-component', SliderComponent);
